import clsx from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Function to merge conditional tailwind classes
 * @param {import("clsx").ClassValue[]} classes
 * @returns {String} Merged classes
 */
export function cn(...classes) {
	return twMerge(clsx(classes));
}
